import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import filter from 'lodash/filter';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Button from 'yoda-core-components/lib/components/Button/Button';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import List from 'yoda-core-components/lib/components/List/List';
import Icon from 'yoda-core-components/lib/components/Icon';
import CloseBanner from '../../assets/svg/closeIconNew.svg';
import SlidePanel from '../SlidePanel/SlidePanel';
import CouponSliderDetails from '../CouponSliderDetails/CouponSliderDetails';
import { selectFeatureFlags, selectDeviceType } from '../../selectors/ContextSelector';
import productPricingSelector, {
    bopisIncentiveProductEligibilitySelector,
} from '../../selectors/ProductPricingSelector';
import * as styles from './FinalPriceAfterCoupon.css';
import productFinalPriceAfterCoupon from '../../selectors/ProductFinalPriceSelector';
import CouponDetailsAction from '../../actions/CouponDetailsAction';
import AnalyticsAction from '../../actions/AnalyticsAction';
import ProductConstants from '../../common/ProductConstants';

const cx = classNames.bind(styles);

/* istanbul ignore next */
export class FinalPriceAfterCoupon extends Component {
    static propTypes = {
        couponPriceDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.object,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        couponDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        pricingDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        displayDetailsLink: PropTypes.bool,
        isSticky: PropTypes.bool,
        couponAmount: PropTypes.number,
        fromMiniPDP: PropTypes.bool,
        showPayOnly: PropTypes.bool,
        alphaId: PropTypes.string,
        eligibilityMessage: PropTypes.string,
        isBundleLevelPrice: PropTypes.bool,
        isBundlePage: PropTypes.bool,
        isNetLevelPrice: PropTypes.bool,
        deviceType: PropTypes.object,
        deliveryOptionsName: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        bopisIncentiveProductEligibility: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    };

    static defaultProps = {
        couponPriceDetails: [],
        featureFlags: {},
        actions: {},
        pricingDetails: {},
        couponDetails: null,
        couponAmount: null,
        displayDetailsLink: true,
        isSticky: false,
        fromMiniPDP: false,
        showPayOnly: false,
        alphaId: '',
        eligibilityMessage: '',
        isBundleLevelPrice: false,
        isBundlePage: false,
        isNetLevelPrice: false,
        deviceType: {},
        deliveryOptionsName: {},
        bopisIncentiveProductEligibility: {},
    };

    state = {
        isModalOpen: false,
        isModalOpenOnce: false,
        shouldOpenModal: false,
    };

    componentWillReceiveProps(nextProps) {
        /* istanbul ignore else  */
        if (
            !isEqual(nextProps.couponDetails, this.props.couponDetails) &&
            this.state.shouldOpenModal
        ) {
            this.getCouponInfo(nextProps.couponDetails);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            !isEqual(nextProps.pricingDetails, this.props.pricingDetails) ||
            isEmpty(this.props.couponPriceDetails) ||
            !isEqual(nextState.isModalOpen, this.state.isModalOpen) ||
            !isEqual(nextProps.couponAmount, this.props.couponAmount) ||
            !isEqual(
                nextProps.bopisIncentiveProductEligibility,
                this.props.bopisIncentiveProductEligibility
            )
        );
    }

    getCouponInfo = (couponDetails) => {
        this.setState({
            shouldOpenModal: false,
        });
        let couponDetailsInfo = null;
        const { couponPriceDetails } = this.props;
        /* istanbul ignore else  */
        if (get(couponPriceDetails, 'couponInfo[0].alphaId', false) && couponDetails) {
            couponDetailsInfo = filter(couponDetails, {
                promoCode: couponPriceDetails.couponInfo[0].alphaId,
            });
        }
        if (couponDetailsInfo && couponDetailsInfo.length) {
            this.openModal();
        } else {
            window.open('/m/jcpenney-coupons/N-mpi6e5');
        }
    };

    openCouponDetails = () => {
        if (this.props.couponDetails && this.props.couponDetails.length) {
            this.getCouponInfo(this.props.couponDetails);
        } else {
            this.setState({
                shouldOpenModal: true,
            });
            this.props.actions.getCouponDetailsAction();
        }
    };

    openModal() {
        this.setState({ isModalOpen: true });
        this.setState((prevState) => ({
            isModalOpenOnce: prevState.isModalOpenOnce ? prevState.isModalOpenOnce : true,
        }));
        this.props.actions.openModalAnalytics('final price after coupon');
    }

    /* istanbul ignore next  */
    closeModal() {
        this.setState({ isModalOpen: false });
    }

    renderSliderTitle = () => {
        return (
            <div
                className={dt([
                    'border-1',
                    'border-gray-15',
                    'border-solid',
                    'h-12',
                    'px-4',
                    'py-2',
                    'shadow-elevation1',
                    'text-black',
                    'flex',
                    'justify-center',
                ])}
            >
                <Button
                    buttonType="Text"
                    className={dt(['absolute', 'top-2.5', 'right-3'])}
                    onClick={() => this.closeModal()}
                >
                    <Icon
                        automationId="at-ydt-bopis-store-icon"
                        iconType="svg"
                        width="28px"
                        height="28px"
                        viewBox="0 0 28 28"
                    >
                        <CloseBanner />
                    </Icon>
                </Button>
            </div>
        );
    };

    capitalize = (str) =>
        str
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');

    render() {
        const {
            featureFlags: {
                displayPriceAfterCouponModal = true,
                fpacEligibilityMessage,
                enableBopisIncentive,
                enableCMCouponfallback,
            },
            couponPriceDetails,
            couponDetails,
            isSticky,
            fromMiniPDP,
            displayDetailsLink,
            deliveryOptionsName,
            bopisIncentiveProductEligibility,
            couponAmount,
            deviceType,
        } = this.props;
        const getEligibilityMessage =
            get(couponPriceDetails, 'couponInfo[0].eligibilityMessage', '') ||
            this.props.eligibilityMessage;
        const eligibilityMessage =
            fpacEligibilityMessage && getEligibilityMessage
                ? this.capitalize(getEligibilityMessage)
                : '';
        const alphaId = this.props.alphaId || get(couponPriceDetails, 'couponInfo[0].alphaId', '');
        let couponDetailsInfo = null;
        /* istanbul ignore else  */
        if (alphaId && couponDetails) {
            couponDetailsInfo = filter(couponDetails, { promoCode: alphaId });
        }

        const renderCouponDetailsContent = (dataItem) => {
            const redeemingChannel =
                dataItem.redeemingChannel && dataItem.redeemingChannel === 'all'
                    ? 'ONLINE & IN-STORE'
                    : `${dataItem.redeemingChannel} ONLY`;
            let headLine = '';
            /* istanbul ignore else  */
            if (dataItem.offers && dataItem.offers.length === 1) {
                headLine = (
                    <div>
                        {' '}
                        <p className={cx('couponHeadline')}> {dataItem.offers[0].headLine} </p>
                        <p className={cx('couponBody')}> {dataItem.offers[0].bodyCopy} </p>
                    </div>
                );
            } else {
                headLine = (
                    <div>
                        {' '}
                        <p className={cx('couponHeadline')}> {dataItem.offers[0].headLine} </p>
                        <p className={cx('couponBody')}> {dataItem.offers[0].bodyCopy} </p>
                        {dataItem.offers[1] && dataItem.offers[1].conjunction ? (
                            <p className={cx('conjunctionline')}>
                                {' '}
                                <span>{dataItem.offers[1].conjunction} </span>
                            </p>
                        ) : null}
                        <p className={cx('couponHeadline')}> {dataItem.offers[1].headLine} </p>
                        <p className={cx('couponBody')}> {dataItem.offers[1].bodyCopy} </p>
                    </div>
                );
            }
            const offerEndDate = (dataItem.offerEndDate && dataItem.offerEndDate.split('T')) || [];
            const offerExpiryDate = offerEndDate.length && offerEndDate[0].split('-');
            const expiryDate =
                (offerExpiryDate &&
                    `${offerExpiryDate[1]}/${offerExpiryDate[2]}/${offerExpiryDate[0]}`) ||
                '';

            const couponValidity = (
                <div className={cx('couponValidity')}>
                    <p>
                        {' '}
                        <span> Code: </span> <span> {dataItem.promoCode} </span>{' '}
                    </p>
                    <p>
                        {' '}
                        <span> Expires: </span> <span> {expiryDate} </span>{' '}
                    </p>
                </div>
            );
            return (
                <div>
                    <div
                        className={`${dt(['p-0', 'font-open-sans'])} ${cx(
                            'couponDetailsBlock',
                            'sm12',
                            'md12',
                            'lg12',
                            'xl12'
                        )}`}
                        data-automation-id="couponDetailsContainer"
                    >
                        <div
                            className={`${dt(['pt-0', 'pr-3', 'pb-0', 'pl-0'])} ${cx(
                                'couponHeaderBlock',
                                'sm12',
                                'md8',
                                'lg8',
                                'xl8'
                            )}`}
                        >
                            <p
                                className={`${dt(['text-xs', 'font-bold', 'text-gray-60'])} ${cx(
                                    'redeemingChannel'
                                )}`}
                            >
                                {' '}
                                {redeemingChannel.toUpperCase()}{' '}
                            </p>
                            {headLine}
                        </div>
                        <div
                            className={`${dt(['px-0 pr-0 pl-3 smOnly:p-0'])} ${cx(
                                'couponValidityBlock',
                                'sm12',
                                'md4',
                                'lg4',
                                'xl4'
                            )}`}
                        >
                            {couponValidity}
                        </div>
                    </div>
                    <p
                        className={`${dt([
                            'font-open-sans',
                            'text-xs',
                            'leading-[1.67]',
                            'text-black',
                            'pt-1',
                        ])} ${cx('disclaimerTemplate')}`}
                    >
                        {' '}
                        {dataItem.disclaimerTemplate}{' '}
                    </p>
                </div>
            );
        };

        const bopisIncentiveEnabled =
            enableBopisIncentive &&
            deliveryOptionsName.selectedOption === ProductConstants.BOPIS_SELECTED_OPTION &&
            bopisIncentiveProductEligibility.currentLotEligible;

        const dtStyles = {
            semiBoldItalicSmall: ['font-semibold', 'italic', 'text-sm', 'leading-5'],
        };

        const stickyConntainerStyle = isSticky ? ['pl-3'] : [''];

        return (
            <div
                className={`${dt([
                    'block',
                    'font-open-sans',
                    'text-brand-red',
                    ...stickyConntainerStyle,
                ])} ${cx('finalPriceContainer')}`}
            >
                {eligibilityMessage && (
                    <div className={`${dt([...dtStyles.semiBoldItalicSmall])} ${cx('couponText')}`}>
                        {eligibilityMessage}
                    </div>
                )}
                <div className={dt(['flex'])}>
                    <div
                        className={`${dt([
                            'font-bold',
                            'text-2xlarge',
                            'leading-8',
                            'self-end',
                            'pr-1',
                        ])} ${cx('finalPrice')}`}
                        data-automation-id="finalPriceAfterCoupon"
                    >
                        {couponAmount ? `$${couponAmount}` : null}
                    </div>
                    <div
                        className={`${dt([
                            'self-center',
                            'pt-[5px]',
                            ...dtStyles.semiBoldItalicSmall,
                        ])} ${cx('couponMessageContainer')}`}
                        data-automation-id="finalPriceCouponInfo"
                    >
                        {alphaId ? (
                            <>
                                <span className={dt(['pr-1'])} data-automation-id="coupon-use-code">
                                    with code
                                </span>
                                {displayDetailsLink && !fromMiniPDP ? (
                                    <span
                                        className={cx('couponCode')}
                                        data-automation-id="coupon-info-code"
                                    >
                                        {displayPriceAfterCouponModal ? (
                                            <Button
                                                buttonType="Link"
                                                className={dt([
                                                    'sm:!text-sm',
                                                    'sm:!text-brand-red',
                                                ])}
                                                automationId="couponDetails"
                                                onClick={this.openCouponDetails}
                                            >
                                                {alphaId}
                                            </Button>
                                        ) : (
                                            <a
                                                href="/m/jcpenney-coupons/N-mpi6e5"
                                                rel="noopener noreferrer"
                                                data-automation-id="couponDetails"
                                                target="_blank"
                                            >
                                                {' '}
                                                {alphaId}
                                            </a>
                                        )}
                                    </span>
                                ) : null}

                                {displayDetailsLink && fromMiniPDP ? (
                                    <span
                                        className={`${dt(['underline'])} ${cx('couponCode')}`}
                                        data-automation-id="coupon-info-code"
                                    >
                                        {alphaId}
                                    </span>
                                ) : null}
                                {/* display FPAC with pickup discount when pickup discount is applicable */}
                                {bopisIncentiveEnabled && (
                                    <span
                                        data-automation-id="coupon-code-pickup-discount"
                                        className={dt([
                                            'pl-1',
                                            isSticky && 'max-w-[135px]',
                                            isSticky && 'block',
                                        ])}
                                    >
                                        and Pickup Discount
                                    </span>
                                )}
                            </>
                        ) : null}
                    </div>
                </div>
                {enableCMCouponfallback && this.state.isModalOpenOnce ? (
                    <SlidePanel
                        isOpenPanel={this.state.isModalOpen}
                        panelIcon="close"
                        panelHeaderRenderer={this.renderSliderTitle}
                        onClosePanel={() => this.closeModal()}
                    >
                        {this.state.isModalOpen ? (
                            <CouponSliderDetails couponDetailsInfo={couponDetailsInfo} />
                        ) : null}
                    </SlidePanel>
                ) : (
                    <ModalBox
                        showModal={this.state.isModalOpen}
                        onClose={() => this.closeModal()}
                        defaultHeader
                        automationId="couponDetails-modal"
                        modalTheme={cx('couponPriceModal')}
                    >
                        <List
                            childRenderer={renderCouponDetailsContent}
                            datasource={couponDetailsInfo}
                            direction="Vertical"
                            automationId="couponDetails-List"
                        />
                    </ModalBox>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    couponPriceDetails: productFinalPriceAfterCoupon(ownProps.fromMiniPDP)(state),
    featureFlags: selectFeatureFlags(state),
    pricingDetails: productPricingSelector(ownProps.fromMiniPDP)(state),
    couponDetails: state.couponDetails,
    deviceType: selectDeviceType(state),
    deliveryOptionsName: state.deliveryOptionsName,
    bopisIncentiveProductEligibility: bopisIncentiveProductEligibilitySelector(
        ownProps.fromMiniPDP
    )(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...CouponDetailsAction, ...AnalyticsAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalPriceAfterCoupon);
